import React from 'react';
import { useMediaQuery } from 'react-responsive';

const ProjectSquare = ({ imageUrl, name, loc }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (isMobile) {
    return (
      <a
        href={`/${name.toLowerCase().replace(/ /g, '-')}`}
        className='w-full aspect-square transition-transform duration-300 ease-in-out hover:scale-105'
      >
        <div
          className='w-full h-full bg-cover bg-center flex flex-col justify-end'
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div className='flex flex-col h-1/3 text-center justify-center items-center font-display text-white bg-dknavy bg-opacity-70 p-2'>
            <span className='font-semi text-lg'>{name}</span>
            <span className='italic text-sm'>{loc}</span>
          </div>
        </div>
      </a>
    );
  }

  // Desktop version
  return (
    <a
      href={`/${name.toLowerCase().replace(/ /g, '-')}`}
      className='w-3/4 aspect-square transition-transform duration-300 ease-in-out hover:scale-105'
    >
      <div
        className='w-full h-full bg-cover bg-center flex flex-col justify-end'
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        <div className='flex flex-col h-1/3 text-center justify-center items-center font-display text-white bg-dknavy bg-opacity-70 p-2'>
          <span className='font-semi text-xl'>{name}</span>
          <span className='italic text-md'>{loc}</span>
        </div>
      </div>
    </a>
  );
};

export default ProjectSquare;
